(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('moderation-company', {
            parent: 'admin',
            url: '/moderation-company?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Axenteev | Modération company'
            },
            views: {
                'content@admin': {
                    templateUrl: 'app/admin/moderation-company/moderation-company.html',
                    controller: 'ModerationCompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        
        })

        
        .state('moderation-company.contribution', {
            parent: 'moderation-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                  
                }).result.then(function() {
                    $state.go('moderation-company',{}, { reload: true });
                }, function() {
                    $state.go('moderation-company');
                });
            }]
        })


        
        .state('moderation-company.edit', {
            parent: 'moderation-company.contribution',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            params: {
                company: {
                    value: {}
                }
            },
            resolve: {
                entity: ['$stateParams', 'ModerationOrganisation', function($stateParams, ModerationOrganisation) {
                    return ModerationOrganisation.get({id : $stateParams.id}).$promise.then(function (moderationCompany) {
                        var  companyToUpdate = moderationCompany;
                        companyToUpdate.moderationId = moderationCompany.id;
                        if (moderationCompany.referencedOrganisation){
                            companyToUpdate.id = moderationCompany.referencedOrganisation.id;
                            companyToUpdate.importId = moderationCompany.referencedOrganisation.importId;
                        } else {
                            companyToUpdate.id = null;
                        }
                        companyToUpdate['positions'] = moderationCompany.mPositions;

                        delete companyToUpdate.mPositions;
                        delete companyToUpdate.referencedOrganisation;
                        companyToUpdate.hasModeration = true;
                        return companyToUpdate;
                    });

                }]
            },
            views: {
                'contrib@': { 
                  templateUrl: 'app/entities/company/company-dialog.html',
                  controller: 'CompanyDialogController',
                  controllerAs: 'vm'
                }
              }
  
        })
        .state('moderation-company.delete', {
            parent: 'moderation-company',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/moderation-company/moderation-company-delete-dialog.html',
                    controller: 'ModerationCompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ModerationOrganisation', function(ModerationOrganisation) {
                            return ModerationOrganisation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('moderation-company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
